module.exports = __webpack_public_path__ + "img/black3.2ca32a58.svg";